import { render, staticRenderFns } from "./TextRecommendationCard.vue?vue&type=template&id=57ceb637&scoped=true"
import script from "./TextRecommendationCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextRecommendationCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextRecommendationCard.vue?vue&type=style&index=0&id=57ceb637&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ceb637",
  null
  
)

export default component.exports